import * as React from 'react';
import { connectStateResults } from 'react-instantsearch-core';
import { useIntl } from '@grandvisionhq/state';
import { NoResults } from '../NoResults/NoResults.js';
import { SearchResultsContent } from './SearchResultsContent.js';

const ConnectedContentListing = connectStateResults(({ searchResults , searchState  })=>{
    const { getLabel  } = useIntl();
    const suggestions = (searchResults === null || searchResults === void 0 ? void 0 : searchResults.nbHits) > 0 ? searchResults.hits : [];
    const { query  } = searchState;
    if ((searchResults === null || searchResults === void 0 ? void 0 : searchResults.nbHits) === 0) {
        return /*#__PURE__*/ React.createElement(NoResults, {
            title: getLabel('search.noResults.title'),
            description: getLabel('search.noResults.text'),
            query: query
        });
    }
    return /*#__PURE__*/ React.createElement(SearchResultsContent, {
        results: suggestions
    });
});

export { ConnectedContentListing };
//# sourceMappingURL=ConnectedResultsContent.js.map
